var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject } from "aurelia-dependency-injection";
import { DialogClientService } from "../services/basics/dialog-client.service";
import { BaseWidget } from "./base-widget";
import { EntityTypeConfigurationHelper } from "../models/basics/basics.models";
import { DialogServiceConstants } from "../constants/basics/dialog.constants";
import { QueriesClientService } from "../services/queries/queries-client.services";
import { bindable } from "aurelia-templating";
import { StringUtilities } from "../utilities/strings";
import * as Enumerable from "linq";
import { SignalClientService } from "../services/basics/signal-client.service";
var EntityFinder = /** @class */ (function (_super) {
    __extends(EntityFinder, _super);
    function EntityFinder(dialogSerivce, entityTypeConfigurationHelper, queryService, signalClientService) {
        var _this = _super.call(this, signalClientService) || this;
        _this.dialogSerivce = dialogSerivce;
        _this.entityTypeConfigurationHelper = entityTypeConfigurationHelper;
        _this.queryService = queryService;
        _this.supportedEntityTypes = [];
        _this.checkForPermission = true;
        return _this;
    }
    EntityFinder.prototype.onSubmit = function () {
        this.dialogSerivce.show(DialogServiceConstants.URLs.EntityFinderModal, this);
    };
    EntityFinder.prototype.onActivate = function (model) {
        this.supportedEntityTypes = model;
    };
    EntityFinder.prototype.normalizeModel = function (entity) {
        var e_1, _a;
        var obj = {};
        try {
            for (var _b = __values(Object.keys(entity)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                obj[StringUtilities.camelize(key)] = entity[key].value;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return obj;
    };
    EntityFinder.prototype.get = function (selectedEntity) {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            var entity = _this.entityTypeConfigurationHelper.getConfiguration([selectedEntity.entityType], _this.supportedEntityTypes)[0];
            var entityWithPerm = _this.entityTypeConfigurationHelper.getConfigurationWithoutPermissions([selectedEntity.entityType], _this.supportedEntityTypes)[0];
            var typeFound = _this.checkForPermission && entity ? entity.uri : (entityWithPerm ? entityWithPerm.uri : null);
            if (typeFound && selectedEntity && selectedEntity.id) {
                var uri = "/odata/" + (typeFound.replace(/\s/g, "")) +
                    "/Genesis.FindIdWithBag(filter='" + selectedEntity.id + "',bag ='" + _this.bag + "')";
                _this.queryService.getData(uri)
                    .then(function (response) {
                    var firstOrDefault = Enumerable.from(response.value)
                        .firstOrDefault(function (a) { return a.id.value == selectedEntity.id; });
                    resolve(_this.normalizeModel(firstOrDefault ? firstOrDefault : {}));
                });
            }
            else {
                resolve(undefined);
            }
        });
        return promise;
    };
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], EntityFinder.prototype, "checkForPermission", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], EntityFinder.prototype, "bag", void 0);
    EntityFinder = __decorate([
        autoinject,
        __metadata("design:paramtypes", [DialogClientService,
            EntityTypeConfigurationHelper,
            QueriesClientService, SignalClientService])
    ], EntityFinder);
    return EntityFinder;
}(BaseWidget));
export { EntityFinder };
